module.exports = __webpack_public_path__ + "img/tab-orders-inactive.fa35ec10.svg";